document.querySelectorAll(".footeraccordion-header").forEach((button) => {
  button.addEventListener("click", () => {
    const footeraccordionContent = button.nextElementSibling;
    const footeraccordionIcon = button.querySelector(".footeraccordion-icon");

    // Close other opened footer accordion contents and reset their icons
    document.querySelectorAll(".footeraccordion-content").forEach((content) => {
      if (content !== footeraccordionContent) {
        content.style.display = "none";
        content.previousElementSibling.querySelector(
          ".footeraccordion-icon"
        ).textContent = "+";
      }
    });

    // Toggle the current footer accordion content and change the icon
    if (footeraccordionContent.style.display === "block") {
      footeraccordionContent.style.display = "none";
      footeraccordionIcon.textContent = "+";
    } else {
      footeraccordionContent.style.display = "block";
      footeraccordionIcon.textContent = "-";
    }
  });
});
